import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NcModule } from '../@evo/nc.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MyInterceptor } from './interceptor';
import { ErrorDialogModule } from 'src/@evo/components/error-message-dialog/error-message-dialog.module';
import { APIConfigService } from './configuration/api.config';
import { SpecialService } from './configuration/special.service';
import { MessageDialogModule } from './components/message-dialog/message-dialog.module';
import { LoaderModule } from './configuration/loader/loader.module';
import { CookieService } from 'ngx-cookie-service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { createTranslateLoader, MyMissingTranslationHandler, NotTranslatedService } from './translate.common';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import * as moment from 'moment';
import { NetworkService } from './configuration/network.service';
import { DatePipe } from '@angular/common';
import { DropDownService } from './pages/Services/drop-downs.service';
import { PoTatPopup } from './components/po-tat-popup/po-tat-popup.component';
import { NullDate } from './globals/null-date-directive';
export function momentAdapterFactory() {
  return adapterFactory(moment);
};

@NgModule({
  declarations: [AppComponent,PoTatPopup,NullDate],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ErrorDialogModule,
    MessageDialogModule,

    // NcModule
    NcModule,
    LoaderModule,
    NgxMaterialTimepickerModule,
    TranslateModule.forRoot({
      //language code
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler,
        deps: [NotTranslatedService]
      },
      isolate: true,
    }),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: momentAdapterFactory })
    // CreateTranslateModule()
  ],
  providers: [
    APIConfigService,
    SpecialService,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyInterceptor,
      multi: true
    },
    NetworkService,
    DatePipe,
    DropDownService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    //console.log(window);
  }

  // static forRoot(config: SharedService): ModuleWithProviders {
  //   return {
  //     ngModule: AppModule,
  //     providers: [
  //       {provide: SharedService, useValue: config }
  //     ]
  //   };
  // }
}
